import { unparse } from "papaparse";

export const exportCSV = (props: {
  fileName: string;
  csvData: [[]] | [{}];
}) => {
  const blob = new Blob([unparse(props.csvData)], {
    type: "text/csv;charset=utf-8",
  });
  if ((window.navigator as any).msSaveOrOpenBlob) {
    (window.navigator as any).msSaveOrOpenBlob(blob, props.fileName);
  } else {
    const link = window.document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = props.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export function getTimestampedCsvFileName(fileName: string) {
  const currDateTime = new Date();
  return `${fileName}-${currDateTime.toLocaleDateString()} at ${currDateTime.toLocaleTimeString()}.csv`;
}
